import {IAutoOrderAccountSettings} from '../../settings-new/models';

/**
 * Ensures numeric auto-order account settings are persisted as numbers, not strings.
 * Schedule documents and form controls may supply string values (e.g. period: "2").
 */
export function normalizeAutoOrderAccountSettings(
  settings: IAutoOrderAccountSettings,
): IAutoOrderAccountSettings {
  return {
    ...settings,
    growth: Number(settings.growth),
    monthsHistory: Number(settings.monthsHistory),
    period: Number(settings.period),
    stockDays: Number(settings.stockDays),
  };
}

/**
 * Normalizes every supplier entry in an unscheduled auto-order request payload.
 */
export function normalizeAutoOrderUnscheduledPayload(
  orderData: Record<string, IAutoOrderAccountSettings>,
): Record<string, IAutoOrderAccountSettings> {
  return Object.fromEntries(
    Object.entries(orderData).map(([supplierCode, settings]: [string, IAutoOrderAccountSettings]) => [
      supplierCode,
      normalizeAutoOrderAccountSettings(settings),
    ]),
  );
}
